import React from 'react';
import { isMobile } from 'react-device-detect';
import AppUpdatesNotification from './components/AppUpdatesNotification';
import OfflineNotification from './components/OfflineNotification';
import ErrorNotification from './components/ErrorNotification';
import AppAnnouncementNotification from './components/AppAnnouncementNotification';
import Notification from './components/Notification';

const Notifications = {
  offline: () => {
    return {
      content: OfflineNotification,
      type: 'warning',
      insert: 'top',
      container: 'top-full',
      animationIn: ['fadeIn'],
      animationOut: ['fadeOut'],
      isMobile: true,
      width: '100%',
      dismiss: {
        duration: 0,
        click: true,
        touch: true,
        showIcon: true,
      },
    };
  },
  appUpdates: () => {
    return {
      content: AppUpdatesNotification,
      type: 'info',
      insert: 'top',
      container: 'top-full',
      animationIn: ['fadeIn'],
      animationOut: ['fadeOut'],
      isMobile: true,
      width: '100%',
      dismiss: {
        duration: 0,
        click: true,
        touch: true,
        showIcon: true,
      },
    };
  },
  appAnnouncement: () => {
    return {
      content: AppAnnouncementNotification,
      type: 'info',
      insert: 'top',
      container: 'top-full',
      animationIn: ['fadeIn'],
      animationOut: ['fadeOut'],
      isMobile: false,
      width: '100%',
      dismiss: {
        duration: 0,
        click: true,
        touch: true,
        showIcon: true,
      },
    };
  },
  error: (error, retry, id) => {
    return {
      id,
      content: <ErrorNotification error={error} retry={retry} />,
      type: 'danger',
      insert: 'top',
      container: isMobile ? 'top-full' : 'top-right',
      animationIn: ['fadeIn'],
      animationOut: ['fadeOut'],
      width: '100%',
      isMobile: true,
      breakPoint: 500,
      dismiss: {
        duration: 0,
        click: true,
        touch: true,
        showIcon: true,
      },
    };
  },
  show: (message, variant = 'info', id) => {
    return {
      id,
      content: <Notification message={message} variant={variant} />,
      type: 'danger',
      insert: 'top',
      container: isMobile ? 'top-full' : 'top-right',
      animationIn: ['fadeIn'],
      animationOut: ['fadeOut'],
      width: '100%',
      isMobile: true,
      breakPoint: 500,
      dismiss: {
        duration: 6000,
        click: true,
        touch: true,
        showIcon: true,
      },
    };
  },
};

export default Notifications;
